import $ from 'jquery';
import { debugMode } from './_global';

$(function(){
	
	// debug - show viewport size
	if(debugMode()) {
		$('body').append('<div class="debug-vpsize"></div>');
		$(window).resize(function(){
			var text = window.innerWidth+' x '+window.innerHeight;
			$('.debug-vpsize').text(text);
		}).trigger('resize');
	}
	
	// debug - show grid
	if(debugMode()) {
		$(document).bind('keypress', function(e){
			if($('input:focus').length == 0) {
				var code = e.keyCode || e.which;
				if(code == 103) $('.grid-overlay').toggleClass('show');
			}
		});
		$('.debug-gridmessage').click(function(){
			$('.grid-overlay').toggleClass('show');
		});
	}
	
});